import React, {PureComponent} from 'react'
import { connect } from 'react-redux'

import myLibraryActions from '../../../../redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import Modalizer from 'components/modalizer/modalizer'
import { localize } from 'helpers/translator'
import LessonCodesLaunchSession from '../../my_library_launch_session.jsx'
import myLibraryStudentPacedMultipleCodesSelector from 'redux/selectors/my_library/my_library_student_paced_multiple_codes_selector'
import StudentPacedSvg from 'assets/images/ic_student_paced.svg'
import sessionTypes from 'helpers/enums/sessionTypes'

class LessonCodesLaunchStudentPacedModal extends PureComponent {

	constructor() {
		super()
		this.handleShareAction = this.handleShareAction.bind(this)
		this.handleLaunchNewStudentPaced = this.handleLaunchNewStudentPaced.bind(this)
		this.handleCancelAction = this.handleCancelAction.bind(this)
		this.handleSaveExpirationDate = this.handleSaveExpirationDate.bind(this)
	}

	handleCancelAction() {
		this.props.actions.closeStudenPacedCodesModal()
	}

	viewSessionProgress = currentCode => {
		this.props.actions.resumeActiveSession(this.props.presentationUid, currentCode.session_uid, sessionTypes.HOMEWORK)
	}

	handleShareAction(currentCode) {
		this.props.actions.shareActiveStudentPacedSession(currentCode, this.props.presentationUid)
	}

	handleLaunchNewStudentPaced() {
		this.props.actions.launchNewHomework(this.props.presentationUid)
	}

	handleSaveExpirationDate(sessionUid, newExpireTime, currentExpireTime) {
		this.props.actions.saveExpirationDate(sessionUid, newExpireTime, currentExpireTime)
	}

	render() {

		return (
			<Modalizer width='558px' modalName={this.props.modalName} closeAction={this.handleCancelAction}>
				<LessonCodesLaunchSession
					actualTimestamp={this.props.actualTimestamp}
					codes={this.props.codes}
					selected_code_uid={this.props.selected_code_uid}
					canChangeExpirationDate={true}
					icon={StudentPacedSvg}
					handleSaveExpirationDate={this.handleSaveExpirationDate}
					handleLaunchNew={this.handleLaunchNewStudentPaced}
					launchNewText={localize('my_library_launch_student_paced_new')}
					handleShareAction={this.handleShareAction}
					canShare={true}
					canResume={this.props.canAccessProgress}
					handleCancelAction={this.handleCancelAction}
					handleSelectedCode={this.viewSessionProgress}
					buttonText={localize('myLibrary_studentPaced_viewProgress')}
					subtitle={localize('my_library_launch_student_paced_subtitle')}
				/>
			</Modalizer>
		)
	}
}

function mapStateToProps(state, ownProps) {
	return myLibraryStudentPacedMultipleCodesSelector(ownProps.presentationUid)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		shareActiveStudentPacedSession: myLibraryActions.shareActiveStudentPacedSession,
		launchNewHomework: myLibraryActions.launchNewHomework,
		closeStudenPacedCodesModal: myLibraryActions.closeStudenPacedCodesModal,
		saveExpirationDate: myLibraryActions.saveExpirationDate,
		resumeActiveSession: myLibraryActions.resumeActiveSession,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LessonCodesLaunchStudentPacedModal)
